import React, { createContext, useContext, ReactNode } from 'react';
import { ScreenGraph } from '../types';

interface ScreenContextType {
  screenGraph: ScreenGraph;
}

const ScreenContext = createContext<ScreenContextType | undefined>(undefined);

export const useScreenContext = () => {
  const context = useContext(ScreenContext);
  if (!context) {
    throw new Error('useScreenContext must be used within a ScreenProvider');
  }
  return context;
};

interface ScreenProviderProps {
  children: ReactNode;
  screenGraph: ScreenGraph;
}

export const ScreenProvider: React.FC<ScreenProviderProps> = ({ 
  children, 
  screenGraph 
}) => {
  return (
    <ScreenContext.Provider value={{ screenGraph }}>
      {children}
    </ScreenContext.Provider>
  );
};
